(function () {
  var allItems = document.querySelectorAll('.header-navigation-menu__item');
  var items = document.querySelectorAll('.header-navigation-menu__item.has-mega');
  var openDelay = 180;
  var openTimer = null;
  var closeDelay = 250;
  var closeTimer = null;

  function clearTimers() {
    if (openTimer) clearTimeout(openTimer);
    if (closeTimer) clearTimeout(closeTimer);
    openTimer = null;
    closeTimer = null;
  }

  function clearAll() {
    items.forEach(function (el) {
      el.classList.remove('mega-active');
    });
  }

  function lockMenuHeight(li) {
    var megaInner = li.querySelector('.mega-menu__inner');
    if (!megaInner) return;

    if (megaInner.dataset.heightLocked === 'true') return;

    var currentHeight = megaInner.getBoundingClientRect().height;

    if (!currentHeight) {
      currentHeight = megaInner.scrollHeight;
    }

    megaInner.style.height = currentHeight + 'px';
    megaInner.style.overflowY = 'auto';
    megaInner.dataset.heightLocked = 'true';
  }

  function open(li) {
    clearTimers();
    clearAll();
    li.classList.add('mega-active');

    requestAnimationFrame(function () {
      lockMenuHeight(li);
    });
  }

  function close(li) {
    clearTimers();
    li.classList.remove('mega-active');
  }

  function scheduleOpen(li) {
    clearTimers();
    clearAll();

    openTimer = setTimeout(function () {
      var megaMenu = li.querySelector('.mega-menu');

      var overLi = li.matches(':hover');
      var overMenu = megaMenu ? megaMenu.matches(':hover') : false;

      if (!overLi && !overMenu) return;

      open(li);
    }, openDelay);
  }

  function scheduleClose(li) {
    if (openTimer) clearTimeout(openTimer);
    if (closeTimer) clearTimeout(closeTimer);

    openTimer = null;
    closeTimer = setTimeout(function () {
      var megaMenu = li.querySelector('.mega-menu');

      var overLi = li.matches(':hover');
      var overMenu = megaMenu ? megaMenu.matches(':hover') : false;

      if (overLi || overMenu) return;

      li.classList.remove('mega-active');
      closeTimer = null;
    }, closeDelay);
  }

  allItems.forEach(function (li) {
    if (li.classList.contains('has-mega') && li.querySelector('.mega-menu__inner')) return;

    li.addEventListener('mouseenter', function () {
      clearTimers();
      clearAll();
    });
  });

  items.forEach(function (li) {
    var megaMenu = li.querySelector('.mega-menu');
    var megaBackdrop = li.querySelector('.mega-backdrop');
    var megaInner = li.querySelector('.mega-menu__inner');

    if (!megaInner) return;

    li.addEventListener('mouseenter', function () {
      scheduleOpen(li);
    });

    li.addEventListener('mouseleave', function () {
      scheduleClose(li);
    });

    if (megaMenu) {
      megaMenu.addEventListener('mouseenter', function () {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = null;
        li.classList.add('mega-active');
      });

      megaMenu.addEventListener('mouseleave', function () {
        scheduleClose(li);
      });
    }

    if (megaBackdrop) {
      megaBackdrop.addEventListener('mouseenter', function () {
        close(li);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      clearTimers();
      clearAll();
    }
  });

  document.addEventListener('click', function (event) {
    var toggleBtn = event.target.closest('[data-show-more]');
    if (!toggleBtn) return;

    var block = toggleBtn.closest('.mega-sublist-block');
    if (!block) return;

    var list = block.querySelector('.mega-sublist');
    if (!list) return;

    var isExpanded = list.classList.toggle('is-expanded');

    toggleBtn.setAttribute('aria-expanded', String(isExpanded));
    toggleBtn.textContent = isExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen';

    if (isExpanded) {
      var scrollContainer = toggleBtn.closest('.mega-menu__inner');
      if (!scrollContainer) return;

      requestAnimationFrame(function () {
        var targetScroll = block.offsetTop + block.offsetHeight - scrollContainer.clientHeight;

        scrollContainer.scrollTo({
          top: Math.max(targetScroll, 0),
          behavior: 'smooth'
        });
      });
    }
  });
})();